<template>
  <v-container fluid class="pa-0 ma-8">
    <v-text-field
      v-model="search"
      :label="$t('search_by_customer_or_meter')"
      variant="outlined"
      rounded
      append-inner-icon="mdi-magnify"
      class="mx-auto"
      width="50%"
      @change="fetchReadings"
    ></v-text-field>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredReadings"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-1"
    >
      <template v-slot:no-data>
        <h3>{{ $t("no_data_available") }}</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>القراءات</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogReading
            :item="item"
            :saveFunction="save"
            :meters="meters"
            mode="add"
            iconName="mdi-plus"
          />
          <DialogSimp
            :v-model="dialogSimp"
            iconName="mdi-delete"
            :confirmFunction="deleteAll"
            :message="messages.delete"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogReading
            :item="item"
            :saveFunction="save"
            :meters="meters"
            mode="edit"
            iconName="mdi-pencil"
          />

          <DialogSimp
            :v-model="dialogSimp"
            iconName="mdi-delete"
            :item="item"
            :confirmFunction="deleteItem"
            :message="messages.delete"
          />
        </v-row>
      </template>
      <template v-slot:[`item.customer_id`]="{ item }">
        <v-container>
          <p>{{ item.customer?.name }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.meter_id`]="{ item }">
        <v-container>
          <p>{{ item.meter.name }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.old_value`]="{ item }">
        <v-container>
          <p>{{ item.previous }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        <v-container>
          <p>
            <!-- {{
              item.previous
                ? item.current_value - item.previous
                : item.current_value
            }} -->
            {{
              item.previous
                ? parseFloat((item.current_value - item.previous).toFixed(3))
                : parseFloat(item.current_value.toFixed(3))
            }}
          </p>
        </v-container>
      </template>
      <template v-slot:[`item.isPrompted`]="{ item }">
        <v-container>
          <p>{{ item.isPrompted == 1 ? $t("yes") : $t("no") }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.readingDate`]="{ item }">
        <v-container>
          <p>
            {{
              new Date(item.created_at).toLocaleString("en-US", {
                timeZone: "Asia/Damascus",
              })
            }}
          </p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogReading from "@/components/dialogs/DialogReading.vue";
import DialogSimp from "@/components/DialogSimp.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

import { api } from "@/plugins/api";

export default {
  components: {
    DialogReading,
    DialogSimp,
    OverlayLoader,
  },
  data: () => ({
    search: "",
    loading: false,
    headers: [
      { title: "العداد", key: "meter_id" },
      { title: "العلبة", key: "meter.parent.name" },
      { title: "التأشيرة الحالية", key: "current_value" },
      { title: "التأشيرة السابقة", key: "old_value" },
      { title: "كمية الاستهلاك", key: "amount" },
      { title: "تمت المطالبة", key: "isPrompted" },
      { title: "تاريخ القراءة", key: "readingDate" },
      { title: "ملاحظات", key: "notes" },
      { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
    },
    readings: [],
    meters: [],
  }),
  computed: {
    filteredReadings() {
      return this.readings;
    },
    meterList() {
      return this.metersList;
    },
  },
  methods: {
    async fetchReadings() {
      const search = this.search.toLowerCase();

      this.loading = true;
      try {
        const response = await api.get(`/readings?search=${search}`);
        this.readings = response.data.data;
      } catch (error) {
        //
      }

      this.loading = false;
    },
    async fetchMetersList() {
      if (this.loading) return;

      this.loading = true;
      // const res = await repo.readings.fetchAll();
      // const res2 = await repo.meters.fetchAll();

      try {
        const response = await api.get(`/meters/list`);
        console.log("meters:", response.data.data);
        this.meters = response.data.data;
      } catch (error) {
        //
      }
      this.loading = false;
    },

    async save(formData, mode) {
      formData.isPrompted = formData.isPrompted ? 1 : 0;
      if (mode == "add") {
        console.log("form", mode, formData);
        const res = await repo.readings.add(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      } else {
        console.log("form", mode, formData);

        const res = await repo.readings.update(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      }
    },
    async deleteItem(item) {
      const res = await repo.readings.delete(item.id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
    async deleteAll() {
      const res = await repo.readings.deleteAll();
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
  },
  async mounted() {
    await this.fetchMetersList();
    //await this.fetchReadings();
  },
};
</script>
